"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8944%3A1595))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.693Z
 */
export const Greece = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2H17V14H1V2Z"
      fill="#F7FCFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 4.75H17V6.2285H1V4.75ZM1 7.4075H17V8.886H1V7.4075ZM17 9.9715H1V11.45H17V9.9715ZM1 2H17V3.5H1V2Z"
      fill="#4564F9"
    />
    <path d="M1 12.5H17V14H1V12.5Z" fill="#4564F9" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2H8.5V8.9H1V2Z"
      fill="#4564F9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2H5.5V4.752H8.5V6.2195H5.5V9.25H4V6.2195H1V4.752H4V2Z"
      fill="#F7FCFF"
    />
    <rect x="1" y="2" width="16" height="12" stroke="#757575" />
  </>,
  "Greece",
  { fill: "none", viewBox: "0 0 18 16" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
